import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { AppBar, Toolbar, IconButton, Typography, Dialog, Grid, FormHelperText,  TextField, Checkbox, FormControlLabel, Button, Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'

const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
}));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    fullWidth: {
        width: "100%"
    },
}));


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SellerPasswordPolicySettings = (props) => {
    const classes = useStyles();

    const [isSavingUser, setIsSavingUser] = useState(false)
    const [showMessageDialog, setShowMessageDialog] = useState(false)
    const [isSavingSuccess, setIsSavingSuccess] = useState(false)
    const [messageDialogMessage, setMessageDialogMessage] = useState("")
    const [emailVerificationDialogMessage, setEmailVerificationDialogMessage] = useState(false)
    const [isSavingEmailVerificationSuccess, setIsSavingEmailVerificationSuccess] = useState(false)
    const [isEmailVerified, setIsEmailVerified] = useState(0);
    const [passwordPolicySettings, setPasswordPolicySettings] = useState({
        password_min_length_chars: "",
        require_uppercase: false,  // Default to false
        require_lowercase: false,  // Default to false
        require_number: false,     // Default to false
        require_special_characters: false,    // Default to false
        expiration_settings: false,
        password_expiration_days: '',
    })

    const [errors, setErrors] = useState({
        minimumPasswordLength: "",
        passwordExpirationDays: ""
    });

    
    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);

        return formData;
    }, new FormData())

    useEffect(() => {
        fetchPasswordPolicySettings();
    }, [props.openDialogSettings])

    const fetchPasswordPolicySettings = async () => {
        const options = {
            method: 'POST',
            url: '/TransactiLitePasswordPolicySettings/fetchSellerPasswordPolicySettings.json'
        }

        const response = await axios(options)
        const is_success = response.data.is_success;
        const password_policy_settings = response.data.password_policy_settings;
        console.log(response);

        if (is_success) {
            setPasswordPolicySettings(password_policy_settings);
        }
    }

    const saveSettings = () => {
        console.log('Saved settings:', passwordPolicySettings);
        const savePasswordPolicySettings = {...passwordPolicySettings}

        const options = {
            method: 'POST',
            url: '/TransactiLitePasswordPolicySettings/saveSellerPasswordPolicySettings.json',
            data: objectToFormData(savePasswordPolicySettings)
          }
           axios(options)
             .then(res => {
      
             
              const isSuccess = res.data.response.is_success
                console.log(res.data.response);
              if(!isSuccess){
                if (res.data.response.errors && res.data.response.errors[0]) {
                    setMessageDialogMessage(res.data.response.errors[0])
                } else {
                    setMessageDialogMessage(res.data.response.message)
                }
                setIsSavingSuccess(false)
                
                setShowMessageDialog(true)

                return;
              }
           
              setIsSavingSuccess(true)
              setMessageDialogMessage("Password Policy Settings saved successfully.")
              setShowMessageDialog(true)
              
             }).catch(error => {
                setIsSavingSuccess(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
               
      
             })
    };
   

    useEffect(() => {
        // If minimum_password_length is set to a valid number like 8 or higher, update has_settings and allow_user_to_change_password to true
        if (Number(passwordPolicySettings.minimum_password_length) >= 6) {
            setPasswordPolicySettings(prevState => ({
                ...prevState,
                has_settings: true,
                allow_user_to_change_password: true
            }));
        }
    }, [passwordPolicySettings.minimum_password_length]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPasswordPolicySettings(prevState => ({
            ...prevState,
            [name]: name === "expiration_settings" ? value === true : value // Convert expiration_settings to boolean
        }));

         // Validation logic
         if (name === "minimum_password_length") {
            if (value < 6) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    minimumPasswordLength: "Password minimum length must be at least 6."
                }));
            } else if (value > 128) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    minimumPasswordLength: "Password minimum length must not exceed 128."
                }));
            } else {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    minimumPasswordLength: ""
                }));
            }
        }

        if (name === "password_expiration_days") {
            if (value < 0) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    passwordExpirationDays: "Password expiration days cannot be negative."
                }));
            } else {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    passwordExpirationDays: ""
                }));
            }
        }
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setPasswordPolicySettings(prevState => ({
            ...prevState,
            [name]: checked  // Set to true or false
        }));
    };

  

    function progressDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={isSavingUser}
                onClose={() => { }}
            >

                <DialogContent>
                    <DialogContentText>
                        Processing... Please wait...
                    </DialogContentText>
                    <LinearProgress color="secondary" />
                </DialogContent>
            </Dialog>
        )
    }


    function messageDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={showMessageDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {messageDialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setShowMessageDialog(false)

                        if (isSavingSuccess) {
                            props.setOpenDialogSettings(false)
                            // window.location.reload();
                        }

                    

                    }}
                        color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

      
    return (
        <div>
                <Dialog fullScreen open={props.openDialogSettings} onClose={() => props.setOpenDialogSettings(false)}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => props.setOpenDialogSettings(false)}
                                aria-label="close"
                                size="large">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="subtitle1" className={classes.title}>
                                {"Password Policy Settings"}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <div className={classes.appBarSpacer}></div>
                    <div style={{ padding: '.5rem' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">Password Minimum Length</Typography>
                                <Typography variant="caption">Enforce a minimum length of characters.</Typography>
                                <TextField
                                    autoComplete='off'
                                    type='number'
                                    fullWidth
                                    value={passwordPolicySettings.minimum_password_length || ""} // Ensure a defined value                                    
                                    name="minimum_password_length"
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    placeholder="Enter password minimum length"
                                    helperText="*Needs to be between 6 to 128."
                                    inputProps={{ min: 6, max: 128 }}
                                />
                                {errors.minimumPasswordLength && <FormHelperText error>{errors.minimumPasswordLength}</FormHelperText>}
                            </Grid>

                            <Grid item xs={12}>
                            <Typography variant="subtitle1">Password Strength</Typography>
                            
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox checked={passwordPolicySettings.require_uppercase} onChange={handleCheckboxChange} name="require_uppercase" />}
                                    label="Require at least one uppercase letter from the Latin alphabet (A-Z)"
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox checked={passwordPolicySettings.require_lowercase} onChange={handleCheckboxChange} name="require_lowercase" />}
                                    label="Require at least one lowercase letter from the Latin alphabet (a-z)"
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox checked={passwordPolicySettings.require_number} onChange={handleCheckboxChange} name="require_number" />}
                                    label="Require at least one number"
                                />
                            </Grid>
                            
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox checked={passwordPolicySettings.require_special_characters} onChange={handleCheckboxChange} name="require_special_characters" />}
                                    label="Require at least one non-alphanumeric character (!@#$%^&*()_+-=[]{}|')"
                                />
                            </Grid>
                        </Grid>


                        <Grid item xs={12}>
                            <Typography variant="subtitle1">Password Expiration Settings</Typography>
                            <Select
                                fullWidth
                                value={passwordPolicySettings.expiration_settings || false} // Ensure a defined value
                                name="expiration_settings"
                                onChange={handleInputChange}
                            >
                                <MenuItem value={true}>ENABLE</MenuItem>
                                <MenuItem value={false}>DISABLE</MenuItem>
                            </Select>
                        </Grid>

                        {passwordPolicySettings.expiration_settings && ( // Only show if ENABLE
                            <Grid item xs={12}>
                                <Typography variant="subtitle1">Set Password Expiration Days</Typography>
                                <TextField
                                    autoComplete='off'
                                    type='number'
                                    fullWidth
                                    value={passwordPolicySettings.password_expiration_days || ""} // Ensure a defined value
                                    name="password_expiration_days"
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    placeholder="Enter password expiration days"
                                    inputProps={{
                                        min: 0, // Set minimum input value to 0
                                    }}
                                />
                                {errors.passwordExpirationDays && <FormHelperText error>{errors.passwordExpirationDays}</FormHelperText>}

                            </Grid>
                        )}


                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" fullWidth onClick={saveSettings}>
                                    Save Setting
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
                <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                    {progressDialog()}
                    {messageDialog()}
                </ThemeProvider>
            </StyledEngineProvider>
        </div>
    );
}

export default SellerPasswordPolicySettings